import { PropsWithChildren } from "react";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import { TopicflowIconMap } from "@components/topicflow-icon/topicflow-icon-helpers";

const ComplianceProgramFormStep = ({
  title,
  canDelete,
  onDelete,
  children,
}: PropsWithChildren<{
  title: string;
  canDelete: boolean;
  onDelete: () => void;
}>) => {
  return (
    <div className="border rounded-md bg-gray-25">
      <div className="pt-6 pb-4 px-6 flex items-center justify-between">
        <div className="tf-header-base-dark">{title}</div>
        {canDelete && (
          <Button
            icon={TopicflowIconMap.trash}
            theme={buttonTheme.iconGray}
            onClick={onDelete}
          />
        )}
      </div>
      {children}
    </div>
  );
};

export default ComplianceProgramFormStep;
